import React from 'react';
import { FaLock, FaHeart, FaMobileAlt, FaUserTie, FaGlobe, FaComments } from 'react-icons/fa';

const Features = () => {
  const features = [
    {
      icon: <FaLock className="text-2xl text-white" />,
      color: "from-blue-500 to-cyan-400",
      title: "Secure & Verified Profiles",
      description: "All profiles are verified to ensure authenticity and your safety."
    },
    {
      icon: <FaHeart className="text-2xl text-white" />,
      color: "from-pink-500 to-rose-400",
      title: "Smart Matching",
      description: "Advanced algorithms find compatible partners based on your preferences."
    },
    {
      icon: <FaMobileAlt className="text-2xl text-white" />,
      color: "from-purple-500 to-indigo-400",
      title: "Mobile App",
      description: "Stay connected on the go with our dedicated mobile application."
    },
    {
      icon: <FaUserTie className="text-2xl text-white" />,
      color: "from-emerald-500 to-teal-400",
      title: "Relationship Experts",
      description: "Get guidance from certified relationship counselors when needed."
    },
    {
      icon: <FaGlobe className="text-2xl text-white" />,
      color: "from-orange-500 to-amber-400",
      title: "Global Community",
      description: "Connect with like-minded individuals from around the world."
    },
    {
      icon: <FaComments className="text-2xl text-white" />,
      color: "from-violet-500 to-fuchsia-400",
      title: "Private Messaging",
      description: "Secure and private communication with your matches."
    }
  ];

  return (
    <section id="features" className="py-24 bg-transparent relative">
      <div className="absolute inset-0 bg-grid-slate-800/10 [mask-image:linear-gradient(0deg,rgba(0,0,0,0.8),rgba(0,0,0,0.4))] z-0"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-20 animate-fade-in-up">
          <span className="text-pink-400 font-semibold tracking-wider uppercase text-sm mb-2 block">Premium Features</span>
          <h2 className="text-4xl lg:text-5xl font-romantic font-bold text-white mb-6">
            Why Choose <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-400 to-rose-400">MarryCenter?</span>
          </h2>
          <p className="text-xl text-white max-w-2xl mx-auto">
            We provide everything you need to find your perfect life partner in a safe, modern environment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="group relative p-8 romantic-glass-card hover:-translate-y-2 overflow-hidden">
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${feature.color} opacity-5 rounded-bl-[100px] -z-10 transition-transform duration-500 group-hover:scale-150 group-hover:opacity-10`}></div>
              
              <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${feature.color} flex items-center justify-center mb-6 shadow-lg transform group-hover:rotate-12 transition-transform duration-300`}>
                {feature.icon}
              </div>
              
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-pink-400 transition-colors">
                {feature.title}
              </h3>
              
              <p className="text-slate-300 leading-relaxed text-sm">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;